"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const aircasting_logo_nav_svg_1 = __importDefault(require("../../../../../assets/images/aircasting-logo-nav.svg"));
const airCastingLogoMobile_svg_1 = __importDefault(require("../../../assets/icons/airCastingLogoMobile.svg"));
const airbeamIcon_svg_1 = __importDefault(require("../../../assets/icons/airbeamIcon.svg"));
const hamburger_svg_1 = __importDefault(require("../../../assets/icons/hamburger.svg"));
const hamburgerMobile_svg_1 = __importDefault(require("../../../assets/icons/hamburgerMobile.svg"));
const urls_1 = require("../../../const/urls");
const media_1 = require("../../../utils/media");
const useScreenSizeDetection_1 = __importDefault(require("../../../utils/useScreenSizeDetection"));
const RealtimeMapUpdatesButton_1 = require("../../atoms/RealtimeMapUpdatesButton/RealtimeMapUpdatesButton");
const RefreshMapButton_1 = require("../../atoms/RefreshMapButton/RefreshMapButton");
const ControlPanel_1 = require("../../organisms/Map/ControlPanel/ControlPanel");
const LocationSearch_1 = require("../LocationSearch");
const BackButton_1 = require("./BackButton");
const NavList_1 = __importDefault(require("./NavList/NavList"));
const S = __importStar(require("./Navbar.style"));
const DesktopHeader = ({ isMapPage, isTimelapseView, navMenuVisible, toggleMenuVisibility, t, onOpenCookieSettings, }) => {
    const isSmallScreen = (0, useScreenSizeDetection_1.default)(media_1.screenSizes.hugeDesktop);
    const isTinyScreen = (0, useScreenSizeDetection_1.default)(media_1.screenSizes.mediumDesktop);
    const isExtraTinyScreen = (0, useScreenSizeDetection_1.default)(media_1.screenSizes.mediocreDesktop);
    return (react_1.default.createElement(S.DesktopContainer, { className: "active-overlay" },
        isMapPage ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(S.Container, null,
                isTinyScreen ? (react_1.default.createElement(S.SmallDesktopContainer, null,
                    react_1.default.createElement(S.SmallDesktopMenuContainer, null,
                        react_1.default.createElement("a", { href: urls_1.urls.aircasting, "aria-label": t("navbar.sections.aircastingPage") },
                            react_1.default.createElement("img", { alt: t("navbar.altLogo"), src: airCastingLogoMobile_svg_1.default })),
                        react_1.default.createElement("nav", null,
                            react_1.default.createElement(S.MenuButton, { onClick: toggleMenuVisibility },
                                react_1.default.createElement("img", { src: hamburgerMobile_svg_1.default, alt: t("navbar.altMenu"), "aria-label": t("navbar.sections.openMenu") })))),
                    react_1.default.createElement(LocationSearch_1.LocationSearch, { isTimelapseView: isTimelapseView }))) : (react_1.default.createElement(S.SearchContainer, null,
                    react_1.default.createElement("a", { href: urls_1.urls.aircasting, "aria-label": t("navbar.sections.aircastingPage") },
                        react_1.default.createElement(S.AircastingLogo, { alt: t("navbar.altLogo"), src: isSmallScreen ? airCastingLogoMobile_svg_1.default : aircasting_logo_nav_svg_1.default, "$isSmallScreen": isSmallScreen })),
                    react_1.default.createElement(LocationSearch_1.LocationSearch, { isTimelapseView: isTimelapseView }))),
                react_1.default.createElement(S.MapControls, { "$isTimelapseView": isTimelapseView },
                    react_1.default.createElement(RefreshMapButton_1.RefreshMapButton, null),
                    react_1.default.createElement(RealtimeMapUpdatesButton_1.RealtimeMapUpdatesButton, null),
                    react_1.default.createElement(ControlPanel_1.ControlPanel, null))))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(BackButton_1.BackButton, null),
            react_1.default.createElement("a", { href: urls_1.urls.aircasting, "aria-label": t("navbar.sections.aircastingPage") },
                react_1.default.createElement(S.AircastingLogo, { alt: t("navbar.altLogo"), src: aircasting_logo_nav_svg_1.default })))),
        react_1.default.createElement(S.Container, null,
            !isExtraTinyScreen && (react_1.default.createElement(S.BuyCTA, { href: urls_1.urls.airbeamBuyNow, className: "active-overlay" },
                isSmallScreen ? "" : t("navbar.sections.getAirbeam"),
                react_1.default.createElement("img", { src: airbeamIcon_svg_1.default, alt: t("navbar.altAirbeamIcon"), "aria-label": t("navbar.altAirbeamIcon") }))),
            !isTinyScreen && (react_1.default.createElement("nav", null,
                react_1.default.createElement(S.MenuButton, { onClick: toggleMenuVisibility, className: "active-overlay" },
                    react_1.default.createElement("img", { src: hamburger_svg_1.default, alt: t("navbar.altMenu"), "aria-label": t("navbar.sections.openMenu") }))))),
        react_1.default.createElement(NavList_1.default, { t: t, navMenuVisible: navMenuVisible, toggleMenuVisibility: toggleMenuVisibility, onOpenCookieSettings: onOpenCookieSettings })));
};
exports.default = DesktopHeader;
